export default {"src":"/_next/static/media/aff-1.0397dfb3.svg","height":20,"width":91};